import { call } from 'redux-saga/effects';
import * as api from 'services/api';

export function* generatorCountryAbbreviations() {
  const { data } = yield call(api.getCountryAbbreviations);

  return data;
}
